// extracted by extract-css-chunks-webpack-plugin
module.exports = {"WindowsToolbar":"WindowsToolbar_2UTqm_v13-0-0","DragRegion":"DragRegion_3yh5T_v13-0-0","RightButtons":"RightButtons_3PG-S_v13-0-0","Menu":"Menu_1e5_y_v13-0-0","Back":"Back_2hzNV_v13-0-0","Minimize":"Minimize_3LwGi_v13-0-0","Maximize":"Maximize_3Xb21_v13-0-0","Quit":"Quit_3TZxN_v13-0-0"};
    if(module.hot) {
      // 1588357789107
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  